export const CARD_RESET_STATE = 'CARD_RESET_STATE';
export const CARD_CURRENT_ITEM = 'CARD_CURRENT_ITEM';

export const CARD_REQUEST_LOADING = 'CARD_REQUEST_LOADING';
export const CARD_REQUEST_SUCCESS = 'CARD_REQUEST_SUCCESS';
export const CARD_REQUEST_FAILED = 'CARD_REQUEST_FAILED';

export const CARD_CURRENT_ACTION = 'CARD_CURRENT_ACTION';
export const CARD_RESET_ACTION = 'CARD_RESET_ACTION';